<template>
  <div class="shensu-info">
    <div class="form-row">
      <div class="lable">系统判断当前订单的提成类型为<span class="danger">{{ orderObj.bonusTypeLabel }}</span>，若您认为是{{newResult.label}}提成请上传证据。</div>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="上传图片证件" prop="fileUrls" class='images' style="line-height: 1; margin-bottom: 14px;">
        <div class="info">（图片最多不超过6张，每张大小不超2M，图片格式支持jpg，jpeg，bmp）</div>
        <!-- <upload-picture :limit="6"  :file-list="form.fileUrls"  @getUrl="getImagesUrl" @handleRemove="removeImagesUrl" class="upload-list" /> -->
        <upload-picture :limit="6" :list="form.fileUrls" @changeImage="changeImage"  class="upload-list" />
      </el-form-item>
      <el-form-item label="修改备注">
        <el-input maxlength="64" show-word-limit placeholder="请输入备注" type="textarea" v-model="form.reason"></el-input>
      </el-form-item>
    </el-form>
    <div class="button-con button-con-right">
      <el-button class="btn-cancel" @click="$emit('dialogVisible')">取 消</el-button>
      <el-button class="btn-ok" type="primary" @click="submit">确 定</el-button>
    </div>
  </div>
</template>

<script>
import uploadPicture from '@/components/upload/pictureList.vue'
export default {
  name: 'set-shensu',
  props: {
    // 传递步骤参数
    orderObj: {
      type: Object,
      default: {}
    },
    visible: {
      type: Boolean
    }
  },
  components: {
    uploadPicture
  },
  computed: {
    // 申诉修改的类型
    newResult () {
      if (this.orderObj.bonusType === 1) {
        return { label: '复购', value: 2 }
      } else {
        return { label: '首购', value: 1 }
      }
    }
  },
  data () {
    return {
      form: {
        fileUrls: [],
        reason: ''
      },
      rules: {
        fileUrls: [{ type: 'array', required: true, message: '上传图片证据', trigger: 'change' }],
      }
    }
  },
  methods: {
    // 获取上传图片文件的链接
    changeImage(val) {
      console.log(val)
      this.form.fileUrls = val
    },
    getImagesUrl(code) {
      const url = this.ImgHttps + code
      this.form.fileUrls.push(url)
      console.log('getImagesUrl', this.form)
    },
    removeImagesUrl(url) {
      console.log('removeImagesUrl', url)
      const delIndex = this.form.fileUrls.findIndex(e => { return e === url })
      this.form.fileUrls.splice(delIndex, 1)
    },
    // 提交
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const urls = this.form.fileUrls.map(e => e.url)
          const postData = {
            orderId: this.orderObj.orderId,
            bonusType: this.newResult.value,
            reason: this.form.reason,
            fileUrls: urls.join(',')
          }
          // console.log('postData', postData, this.orderObj)
          // return
          this.$api.orderBonusModify(postData).then((res) => {
            console.log('res:', res, this.$message)
            if (res.code === 0) {
              this.$message.success('提成修改成功')
              this.$emit('submitState')
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      })
    }
  },
  watch: {
    visible: {
      handler (newVal) {
        // 当弹窗显示时重置表单
        this.form.reason = ''
        this.form.fileUrls = []
        this.$refs.form.resetFields()
        console.log('this.form', this.form)
      },
      immediate: true
    }
  }
}
</script>

